export const FEED_DRAWER_WIDTH = 600;
